export const storageKeys = {
    isEmailChangeSuccessful: 'isEmailChangeSuccessful',
};
//# sourceMappingURL=storageKeys.js.map